import { useId } from 'react'
import { ModalOverlay } from './ui/ModalOverlay'
import { XCloseIcon, CreditCardIcon, BankIcon } from './ui'

interface UpdatePaymentMethodChoiceModalProps {
  onClose: () => void
  onSelectCard: () => void
  onSelectDirectDebit: () => void
}

export default function UpdatePaymentMethodChoiceModal({
  onClose,
  onSelectCard,
  onSelectDirectDebit,
}: UpdatePaymentMethodChoiceModalProps) {
  const titleId = useId()

  return (
    <ModalOverlay
      open
      onClose={onClose}
      ariaLabelledBy={titleId}
      panelClassName="flex w-full max-w-[480px] flex-col overflow-clip rounded-2xl bg-background-primary shadow-xl"
    >
      <div className="relative flex w-full shrink-0 flex-col items-center">
        <div className="relative flex w-full shrink-0 flex-col items-start gap-[16px] px-[16px] pb-[8px] pt-[20px]">
          <button
            type="button"
            onClick={onClose}
            className="absolute right-[12px] top-[12px] z-20 flex size-[44px] cursor-pointer items-center justify-center overflow-clip rounded-md p-[8px]"
            aria-label="Close"
          >
            <div className="relative size-6 shrink-0 overflow-clip text-text-tertiary-600">
              <XCloseIcon className="h-6 w-6" />
            </div>
          </button>

          <div className="relative flex w-full shrink-0 flex-col items-start gap-[2px] pr-[40px]">
            <h2
              id={titleId}
              className="relative w-full shrink-0 font-display text-display-xs font-semibold leading-[32px] text-text-primary-900"
            >
              Choose payment method
            </h2>
            <p className="relative w-full shrink-0 font-body text-sm font-regular leading-[24px] text-text-tertiary-600">
              Select whether you want to pay by card or set up direct debit from your bank account.
            </p>
          </div>

          <div className="flex w-full flex-col items-stretch gap-[12px]">
            <button
              type="button"
              className="flex w-full items-center gap-3 rounded-lg border border-border-secondary bg-background-primary px-4 py-3 text-left font-body text-md hover:bg-background-secondary"
              onClick={onSelectCard}
            >
              <span className="shrink-0 text-text-tertiary-600">
                <CreditCardIcon className="h-6 w-6" />
              </span>
              <span>
                <span className="block font-semibold text-text-primary-900">Credit or debit card</span>
                <span className="text-sm text-text-tertiary-600">Visa or Mastercard</span>
              </span>
            </button>
            <button
              type="button"
              className="flex w-full items-center gap-3 rounded-lg border border-border-secondary bg-background-primary px-4 py-3 text-left font-body text-md hover:bg-background-secondary"
              onClick={onSelectDirectDebit}
            >
              <span className="shrink-0 text-text-tertiary-600">
                <BankIcon className="h-6 w-6" />
              </span>
              <span>
                <span className="block font-semibold text-text-primary-900">Direct debit</span>
                <span className="text-sm text-text-tertiary-600">Australian bank account (BSB and account number)</span>
              </span>
            </button>
          </div>
        </div>
        <div className="h-[16px] w-full shrink-0" />
      </div>
    </ModalOverlay>
  )
}
